module.exports = __webpack_public_path__ + "static/media/arrow-left.cc73718d.svg";